/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Download_DisabledInputs */

const cs_share_download_disabled = /** @type {(inputs: Share_Download_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stahování je u tohoto sdílení vypnuté.`)
};

const en_share_download_disabled = /** @type {(inputs: Share_Download_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloads are disabled for this share.`)
};

/**
* | output |
* | --- |
* | "Downloads are disabled for this share." |
*
* @param {Share_Download_DisabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const share_download_disabled = /** @type {((inputs?: Share_Download_DisabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Download_DisabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_download_disabled(inputs)
	return cs_share_download_disabled(inputs)
});